import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getExportOperatorPresence = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/attendance/export?${queries}`, responseType: 'blob' });

  return data;
};

export default getExportOperatorPresence;
